import GenericBanner from './banner.desktop';

export default GenericBanner;
